import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css'
import { Topbar } from '../topbar'
import { Banner } from '../banner'
import { useTrip } from '../../contexts/TripContext'
import { useReservation } from '../../contexts/ReservationContext'
import axios from 'axios';
import { Footer } from '../footer';
import { useLoader } from '../../contexts/LoaderContext';
import { useTranslation } from 'react-i18next';

export const Vehiculos = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { tripData } = useTrip();
  const [tarifas, setTarifas] = useState([]);
  const [vehiculos, setVehiculos] = useState([]);
  const navigate = useNavigate();
  const hasRequested = useRef(false);
  const { showLoader, hideLoader } = useLoader();
  
  const { setReservation } = useReservation();
  const [requestsCompleted, setRequestsCompleted] = useState(0); // contador de peticiones completadas
  const timeoutRef = useRef(null); // referencia para timeout de seguridad

  useEffect(() => {
    if (tripData && !hasRequested.current) {
      hasRequested.current = true;

      showLoader(1000, t("vehiculos.cargando")); // Mostrar loader mínimo 1 segundo

      // Timeout de seguridad: 10 segundos máximo
      timeoutRef.current = setTimeout(() => {
        hideLoader();
        console.warn('Timeout de seguridad activado: ocultando loader');
      }, 10000); // 10,000 ms = 10 segundos

      axios.post(`${process.env.REACT_APP_API_URL}new-shuttle`, tripData)
        .then(res => setTarifas(res.data))
        .catch(console.error)
        .finally(() => {
          setRequestsCompleted(prev => prev + 1);
        });

      axios.get(`${process.env.REACT_APP_API_URL}getVehicles`)
        .then(res => setVehiculos(res.data))
        .catch(console.error)
        .finally(() => {
          setRequestsCompleted(prev => prev + 1);
        });
    }

    // Cleanup por si el usuario se sale antes
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [tripData]);

  useEffect(() => {
    if (requestsCompleted === 2) {
      hideLoader();
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current); // Cancelamos el timeout si ya terminó
      }
    }
  }, [requestsCompleted]);

  const handleReserve = (tarifa, vehiculo, tripData) => {
    const cJSON = {
      Hotel: tripData.Hotel || tripData.hotel_name,
      PagoTotal: tarifa.price,
      pax: tripData.pax || tripData.passengers,
      departure_date: tripData.departure_date,
      arrival_date: tripData.arrival_date,
      type_trip: tripData.type_trip,
      zone_id: tripData.zone_id,
      bton_paypal: tarifa.paypal_button || '',
    };

    setReservation({ cJSON, tarifa, vehiculo, tripData });
    navigate('/Form');
  };
  console.log('Tarifas:', tarifas);
  return (
    <>
      <Topbar />
      <Banner />
      <div className="container mt-5 pb-5">
        <div className="row">
          <div className="col-12">
            {tarifas.map((tarifa) => {
              const vehiculo = vehiculos.find(v =>
                tarifa.min === v.pax_min && tarifa.max === v.pax_max
              );

              return vehiculo ? (
                <div key={tarifa.id} className="card mb-4 shadow-sm bg-white">
                  <div className="row g-0">
                    {/* Imagen */}
                    <div className="col-md-4 d-flex flex-column align-items-center p-2">
                      <img
                        src={'/' + vehiculo.url || 'https://via.placeholder.com/300x200?text=Sin+imagen'}
                        alt={vehiculo.nombre}
                        className="img-fluid rounded img-vehiculo mb-2"
                      />
                      <small className="text-muted fst-italic">{t("vehiculos.imagen_ilustrativa")}</small>
                    </div>

                    {/* Info */}
                    <div className="col-md-5 d-flex flex-column justify-content-between p-4">
                      <div>
                        <h5 className="card-title fw-bold text-primary">{vehiculo.nombre}</h5>
                        <ul className="list-unstyled">
                          <li><strong><i className="fa fa-check text-success" aria-hidden="true"></i> Pax:</strong> {vehiculo.pax_min} - {vehiculo.pax_max}</li>
                          <li><strong><i className="fa fa-check text-success" aria-hidden="true"></i> Tipo de viaje:</strong> {tarifa.type_trip === 1 ? 'Redondo' : 'Sencillo'}</li>
                          <li><strong><i className="fa fa-check text-success" aria-hidden="true"></i> Precio:</strong> <i className="fa fa-dollar-sign" aria-hidden="true"></i> {tarifa.price} USD</li>
                          <li><strong><i className="fa fa-check text-success" aria-hidden="true"></i> <i className="fa fa-snowflake text-primary" aria-hidden="true"></i> AC</strong></li>
                          {vehiculo.categories?.map((cat) => (
                            <li key={cat.id}><strong><i className="fa fa-check text-success" aria-hidden="true"></i> {cat.nombre}</strong></li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* Botón */}
                    <div className="col-md-3 d-flex align-items-center justify-content-center">
                      <button
                        onClick={() => handleReserve(tarifa, vehiculo, tripData)}
                        className="btn btn-primary w-75"
                      >
                        {t("vehiculos.reserva_ahora")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : null;
            })}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Vehiculos;